"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeatsioClient = void 0;
var Accounts_1 = require("./Accounts/Accounts");
var Users_1 = require("./Users/Users");
var Invitations_1 = require("./Invitations/Invitations");
var Charts_1 = require("./Charts/Charts");
var Events_1 = require("./Events/Events");
var Workspaces_1 = require("./Workspaces/Workspaces");
var HoldTokens_1 = require("./HoldTokens/HoldTokens");
var ChartReports_1 = require("./Reports/ChartReports");
var EventReports_1 = require("./Reports/EventReports");
var UsageReports_1 = require("./Reports/UsageReports");
var errorInterceptor_1 = require("./errorInterceptor");
var Seasons_1 = require("./Seasons/Seasons");
var axios_1 = __importDefault(require("axios"));
var EventLog_1 = require("./EventLog/EventLog");
var SeatsioClient = /** @class */function () {
  function SeatsioClient(region, secretKey, workspaceKey, extraHeaders) {
    if (workspaceKey === void 0) {
      workspaceKey = undefined;
    }
    if (extraHeaders === void 0) {
      extraHeaders = {};
    }
    // @ts-expect-error TS(2345): Argument of type '{ baseURL: string; auth: { username... Remove this comment to see the full error message
    this.client = axios_1.default.create(this._axiosConfig(region.url, secretKey, workspaceKey, extraHeaders));
    this._setupRequestListenerInterceptors();
    // @ts-ignore
    this.client.maxRetries = 5;
    this.client.interceptors.response.use(function (response) {
      return response;
    }, exponentialBackoffInterceptor(this.client));
    this.errInterceptor = this.client.interceptors.response.use(function (response) {
      return response;
    }, errorInterceptor_1.errorResponseHandler);
    this.charts = new Charts_1.Charts(this.client);
    this.events = new Events_1.Events(this.client);
    this.workspaces = new Workspaces_1.Workspaces(this.client);
    this.users = new Users_1.Users(this.client);
    this.invitations = new Invitations_1.Invitations(this.client);
    this.holdTokens = new HoldTokens_1.HoldTokens(this.client);
    this.accounts = new Accounts_1.Accounts(this.client);
    this.chartReports = new ChartReports_1.ChartReports(this.client);
    this.eventReports = new EventReports_1.EventReports(this.client);
    this.usageReports = new UsageReports_1.UsageReports(this.client);
    this.seasons = new Seasons_1.Seasons(this.client, this);
    this.eventLog = new EventLog_1.EventLog(this.client, this);
  }
  SeatsioClient.prototype._axiosConfig = function (baseUrl, secretKey, workspaceKey, extraHeaders) {
    var config = {
      baseURL: baseUrl,
      auth: {
        username: secretKey,
        password: null
      },
      headers: extraHeaders,
      errorHandle: false,
      paramsSerializer: {
        indexes: null
      }
    };
    config.headers['X-Client-Lib'] = 'js';
    if (workspaceKey) {
      config.headers['X-Workspace-Key'] = workspaceKey;
    }
    return config;
  };
  SeatsioClient.prototype._setupRequestListenerInterceptors = function () {
    var _this = this;
    this.client.interceptors.request.use(function (config) {
      if (_this.requestListener) {
        config.listener = _this.requestListener();
        config.listener.onRequestStarted();
      }
      return config;
    });
    this.client.interceptors.response.use(function (response) {
      if (response.config.listener) {
        response.config.listener.onRequestEnded();
      }
      return response;
    }, function (response) {
      if (response.config.listener) {
        response.config.listener.onRequestEnded();
      }
      return Promise.reject(response);
    });
  };
  SeatsioClient.prototype.setRequestListener = function (requestListener) {
    this.requestListener = requestListener;
    return this;
  };
  SeatsioClient.prototype.setMaxRetries = function (maxRetries) {
    // @ts-ignore
    this.client.maxRetries = maxRetries;
    return this;
  };
  return SeatsioClient;
}();
exports.SeatsioClient = SeatsioClient;
function exponentialBackoffInterceptor(axios) {
  return function (response) {
    if (response.response.status !== 429) {
      return Promise.reject(response);
    }
    var config = response.config;
    if (!config) {
      return Promise.reject(response);
    }
    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= axios.maxRetries) {
      return Promise.reject(response);
    }
    var backoff = new Promise(function (resolve) {
      var waitTime = Math.pow(2, config.__retryCount + 2) * 100;
      config.__retryCount++;
      // @ts-expect-error TS(2794): Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
      setTimeout(function () {
        return resolve();
      }, waitTime);
    });
    return backoff.then(function () {
      return axios(config);
    });
  };
}